// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function () {
    const lazyImages = document.querySelectorAll("img[data-src]");

    function loadImage(img) {
        return new Promise((resolve, reject) => {
            const tempImage = new Image();
            tempImage.src = img.dataset.src;
            tempImage.onload = () => {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.closest('.lazy-image').classList.add("loaded");
                resolve();
            };
            tempImage.onerror = reject;
        });
    }

    if ("IntersectionObserver" in window) {
        const lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const lazyImage = entry.target;
                    loadImage(lazyImage).catch(console.error);
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function (lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Fallback para navegadores que no soportan IntersectionObserver
        lazyImages.forEach(function (lazyImage) {
            loadImage(lazyImage).catch(console.error);
        });

    }

    // Initialize Carousels manually
    if (typeof understrap !== 'undefined' && understrap.Carousel) {
        var carousels = document.querySelectorAll('.carousel');
        carousels.forEach(function (carouselElement) {
            if (carouselElement.getAttribute('data-bs-ride') === 'false') {
                new understrap.Carousel(carouselElement, {
                    interval: false,
                    ride: false
                });
            } else {
                new understrap.Carousel(carouselElement, {
                    interval: carouselElement.hasAttribute('data-bs-interval') ? parseInt(carouselElement.getAttribute('data-bs-interval'), 10) : 5000,
                    ride: 'carousel'
                });
            }
        });
    }

    // Initialize tooltips
    if (typeof understrap !== 'undefined' && understrap.Tooltip) {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new understrap.Tooltip(tooltipTriggerEl);
        });
    }
});